// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/admin_city.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { AdminCityService } from "./admin_city_pb";

/**
 * ListAllCities returns every city in every status (incl. not-yet-ready).
 *
 * @generated from rpc travplaces.v1.AdminCityService.ListAllCities
 */
export const listAllCities = AdminCityService.method.listAllCities;

/**
 * CreateCity adds a city from its bounding box; the centre is the box mid.
 *
 * The request/response keep an Admin* prefix (rather than the lint-standard
 * CreateCityRequest/Response) because those names are already taken by
 * CityService in this same package.
 * buf:lint:ignore RPC_REQUEST_STANDARD_NAME
 * buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
 *
 * @generated from rpc travplaces.v1.AdminCityService.CreateCity
 */
export const createCity = AdminCityService.method.createCity;

/**
 * UpdateCity patches a city's mutable fields; unset fields are left as-is.
 *
 * @generated from rpc travplaces.v1.AdminCityService.UpdateCity
 */
export const updateCity = AdminCityService.method.updateCity;

/**
 * DeleteCity removes a city and its POIs (cascade).
 *
 * Admin* prefix for the same reason as CreateCity: DeleteCityRequest/Response
 * already exist on CityService in this package.
 * buf:lint:ignore RPC_REQUEST_STANDARD_NAME
 * buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
 * UnpublishCity takes a city out of the planner and out of the shared map
 * and routing data, without deleting it.
 *
 * @generated from rpc travplaces.v1.AdminCityService.UnpublishCity
 */
export const unpublishCity = AdminCityService.method.unpublishCity;

/**
 * @generated from rpc travplaces.v1.AdminCityService.DeleteCity
 */
export const deleteCity = AdminCityService.method.deleteCity;

/**
 * FetchBoundary reports the city's boundary coverage (simplified: bbox only).
 *
 * @generated from rpc travplaces.v1.AdminCityService.FetchBoundary
 */
export const fetchBoundary = AdminCityService.method.fetchBoundary;

/**
 * SystemStatus reports basic engine/health status (simplified: db liveness).
 *
 * @generated from rpc travplaces.v1.AdminCityService.SystemStatus
 */
export const systemStatus = AdminCityService.method.systemStatus;
